import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'

export default {
  install(Vue) {
    Vue.prototype.getPdf = function (options) {
      var title = options.htmlTitle
      html2Canvas(document.querySelector(options.selector), {
        allowTaint: true
      }).then(function (canvas) {
          let contentWidth = canvas.width;
          let contentHeight = canvas.height;
          let pageHeight = contentWidth / 592.28 * 841.89;
          let leftHeight = contentHeight;
          let position = 0;
          let imgWidth = 595.28;
          let imgHeight = 592.28 / contentWidth * contentHeight;
          let pageData = canvas.toDataURL('image/jpeg', 1.0);
          if (options.type === 'pdf') {
            let PDF = new JsPDF('', 'pt', 'a4')
            if (leftHeight < pageHeight) {
              PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
            } else {
              while (leftHeight > 0) {
                PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
                leftHeight -= pageHeight;
                position -= 841.89;
                if (leftHeight > 0) {
                  PDF.addPage();
                }
              }
            }
            PDF.save(title + '.pdf');
          } else {
            let a = document.createElement('a');
            a.setAttribute('href', pageData);
            a.setAttribute('download', title + ".png");
            document.body.appendChild(a);
            a.click();
            a.remove();
          }
        }
      )
    }
    Vue.prototype.printHtml = function (options) {
      let content = '';
      var mywindow = window.open('', '_blank');
      mywindow.document.write('<html><head><title>' + options.htmlTitle + '</title>');
      mywindow.document.write('</head><body style="margin:0 auto">');
      mywindow.document.write('</body></html>');
      if(options.type === 'canvas'){
        html2Canvas(document.querySelector(options.selector), {
          allowTaint: true,
        }).then(function (canvas) {
          content = canvas;
          content.style.width = document.querySelector(options.selector).offsetWidth;
          mywindow.document.body.appendChild(content);
          mywindow.document.close(); 
          mywindow.focus(); 
          mywindow.print();
          mywindow.close();
          return true;
        })
      }else{
        content = document.querySelector(options.selector).cloneNode(true);
        content.style.width = '100%';
        mywindow.document.body.appendChild(content);
        mywindow.document.close(); 
        mywindow.focus(); 
        mywindow.print();
        mywindow.close();
      }
    }
  }
}
